import { apiFetch, setAccessToken } from '../lib/api';
import type { components } from '../types/api';

type AuthResponse = components['schemas']['AuthResponse'];
type UserProfile = components['schemas']['UserProfileResponse'];

export async function login(email: string, password: string): Promise<AuthResponse> {
  const res = await apiFetch<AuthResponse>('/api/auth/login', {
    method: 'POST', body: { email, password },
  });
  setAccessToken(res.token);
  return res;
}

export interface RegisterResult { message: string; email: string; }

export async function register(email: string, password: string, displayName: string): Promise<RegisterResult> {
  return apiFetch<RegisterResult>('/api/auth/register', {
    method: 'POST', body: { email, password, displayName },
  });
}

export async function logout(): Promise<void> {
  try { await apiFetch<void>('/api/auth/logout', { method: 'POST' }); }
  finally { setAccessToken(null); }
}

export async function getMe(): Promise<UserProfile> {
  return apiFetch<UserProfile>('/api/auth/me');
}

export async function forgotPassword(email: string): Promise<{ message: string }> {
  return apiFetch('/api/auth/forgot-password', { method: 'POST', body: { email } });
}

export async function resetPassword(email: string, token: string, newPassword: string): Promise<{ message: string }> {
  return apiFetch('/api/auth/reset-password', { method: 'POST', body: { email, token, newPassword } });
}

export async function confirmEmail(userId: string, token: string): Promise<{ message: string }> {
  const qs = new URLSearchParams({ userId, token }).toString();
  return apiFetch(`/api/auth/confirm-email?${qs}`);
}

export async function resendConfirmation(email: string): Promise<{ message: string }> {
  return apiFetch('/api/auth/resend-confirmation', { method: 'POST', body: { email } });
}
